import React, { useEffect, useState } from "react";
import BusinessInfoHeader from "../../components/BusinessInfoHeader";
import GalleryAdd from "../../assets/svgs/Gallery-Add.svg";
import nprogress from "nprogress";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  acceptContract,
  addServicePricing,
  editContract,
  fetchAllLgas,
  fetchAllStates,
  fetchImageLink,
  loginUser,
  submitProviderInfo,
} from "../../features/user/userSlice";
import { useFormik } from "formik";
import {
  Accordion,
  AccordionItem,
  AccordionItemPanel,
} from "react-accessible-accordion";
import BusinessAccordionHeader from "../../components/BusinessAccordionHeader";
import AddBusinessAddressSection from "../../components/AddBusinessAddressSection";
import Schedule from "../../components/Schedule.js";
import BusinessInfoImage from "../../components/BusinessInfoImage.js";
import { Input } from "../../components/forms";
import PhoneInput from "../../components/forms/PhoneInput.js";
import Button from "../../components/Button.js";
import { convertTo12HourFormat } from "../../utils/helper.js";
import { useNavigate } from "react-router-dom";

const InvitedProvidingOnboarding = () => {
  const navigate = useNavigate();
  const [uploadingImage, setUploadingImage] = useState(false);
  const [previewProfile, setPreviewProfile] = useState("");
  const [stateName, setStateName] = useState("");
  const [addImages, setAddImages] = useState([
    { image: "", isCoverphoto: true },
    { image: "", isCoverphoto: false },
    { image: "", isCoverphoto: false },
    { image: "", isCoverphoto: false },
  ]);
  const { allState, stateLga, userImgLink, isLoading } = useSelector(
    (store) => store.user
  );
  const invitedUser = localStorage.getItem("inviteData");
  const user = invitedUser ? JSON.parse(invitedUser) : null;
  const [phoneDetails, setPhoneDetails] = useState({});
  const [visibleImageInputs, setVisibleImageInputs] = useState(2);
  function removeQueryString(url) {
    return url.split("?")[0];
  }
  const [daysOfWeek, setDaysOfWeek] = useState([
    { day: "Monday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Tuesday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Wednesday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Thursday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Friday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Saturday", openTime: "07:00", closeTime: "20:00", isOpen: true },
    { day: "Sunday", openTime: "07:00", closeTime: "20:00", isOpen: true },
  ]);
  const dispatch = useDispatch();
  const uploadToAws = async (fileUpload, index) => {
    nprogress.start();
    setUploadingImage(true);
    try {
      const res = await axios.put(userImgLink, fileUpload, {
        headers: {
          "Content-Type": fileUpload.type,
        },
      });
      const result = res?.config?.url;
      nprogress.done();
      toast.success("Image uploaded successfully");
      if (index === -1) {
        setPreviewProfile(removeQueryString(result));
      } else {
        setAddImages((prevArray) =>
          prevArray.map((item, idx) =>
            idx === index ? { ...item, image: removeQueryString(result) } : item
          )
        );
      }
      dispatch(fetchImageLink());
      setUploadingImage(false);
    } catch (error) {
      nprogress.done();
      setUploadingImage(false);
      dispatch(fetchImageLink());
      toast.error("Error uploading image");
      console.error("Error uploading image", error);
    }
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      uploadToAws(file, -1);
    }
  };
  const handleCheckboxChange = (index) => {
    setAddImages((prevArray) =>
      prevArray.map((item, idx) =>
        idx === index
          ? { ...item, isCoverphoto: true }
          : { ...item, isCoverphoto: false }
      )
    );
  };

  const handleImageMultipleChange = (event, index) => {
    const file = event.target.files[0]; // Get the selected file
    uploadToAws(file, index);
  };
  const showMoreInputs = () => {
    setVisibleImageInputs((prevVisible) =>
      Math.min(prevVisible + 2, addImages.length)
    );
  };

  const { handleChange, values, submitForm } = useFormik({
    initialValues: {
      selectedState: "",
      selectedCountry: "",
      selectedLga: "",
      zipCode: "",
      streetAddress: "",
      instaLink: "",
      membershipPrice: "",
      startPrice: "",
      websiteLink: "",
    },
    onSubmit: (values) => {
      dispatch(
        submitProviderInfo({
          providerLogo: previewProfile,
          instagramLink: values?.instaLink,
          providerName: user?.data?.providerName,
          providerCategoryIds: user?.data?.providerCategories.map(
            (item) => item.id
          ),
          branchInfo: [
            {
              branchName: user?.data?.providerName,
              country: values?.selectedCountry,
              region: stateName,
              city: values?.selectedLga,
              zipCode: values?.zipCode,
              contactAddress: values?.streetAddress,
              contactEmail: user?.data?.email,
              contactPhoneNumbers: phoneDetails?.phoneNumber,
              callingCode: phoneDetails?.country?.dialCode,
              website: values?.websiteLink,
              startingPriceMonthly: values?.startPrice,
              membershipFee: values?.membershipPrice,
              coverPhoto: coverPhoto?.image,
              membershipFeeOccurrence: "MONTHLY",
              photos: addImages.map((img) => (img?.image ? img?.image : "")),
              equipment: [],
              amenities: [],
              classes: [],
              activities: [],
              operationHours: daysOfWeek
                .filter((items) => items.isOpen)
                .map((items) => ({
                  day: items.day,
                  time: `${convertTo12HourFormat(
                    items?.openTime || "9:00 AM"
                  )} - ${convertTo12HourFormat(
                    items?.closeTime || "9:00 PM"
                  )} `,
                })),
            },
          ],
          countryCodes: [phoneDetails?.country?.code],
        })
      ).then((res) => {
        if (res?.type === "user/submitProviderInfo/fulfilled") {
          const pricings = localStorage.getItem("providerPricing");
          const services = invitedUser ? JSON.parse(pricings) : null;
          const loginData = localStorage.getItem("loginInfo");
          const userLoginInfo = invitedUser ? JSON.parse(loginData) : null;
          const resellerPricings = localStorage.getItem(
            "providerInvitationPricing"
          );
          const resellerServices = resellerPricings
            ? JSON.parse(resellerPricings)
            : null;

          if (services) {
            dispatch(addServicePricing(services)).then((res) => {
              if (res?.type === "user/addServicePricing/fulfilled") {
                localStorage.removeItem("providerPricing");
                localStorage.removeItem("inviteData");
                localStorage.setItem(
                  "loginData",
                  JSON.stringify(userLoginInfo?.username)
                );
                dispatch(loginUser(userLoginInfo)).then((res) => {
                  localStorage.removeItem("loginInfo");
                  if (res?.type === "user/loginUser/fulfilled") {
                    navigate("/");
                  }
                });
              }
            });
          } else {
            if (resellerServices?.status === "ACCEPTED") {
              dispatch(acceptContract(resellerServices)).then((res) => {
                if (res?.type === "user/acceptContract/fulfilled") {
                  localStorage.removeItem("providerInvitationPricing");
                  localStorage.removeItem("inviteData");
                  localStorage.setItem(
                    "loginData",
                    JSON.stringify(userLoginInfo?.username)
                  );
                  dispatch(loginUser(userLoginInfo)).then((res) => {
                    localStorage.removeItem("loginInfo");
                    if (res?.type === "user/loginUser/fulfilled") {
                      navigate("/");
                    }
                  });
                }
              });
            } else {
              dispatch(editContract(resellerServices)).then((res) => {
                if (res?.type === "user/editContract/fulfilled") {
                  localStorage.removeItem("providerInvitationPricing");
                  localStorage.removeItem("inviteData");
                  localStorage.setItem(
                    "loginData",
                    JSON.stringify(userLoginInfo?.username)
                  );
                  dispatch(loginUser(userLoginInfo)).then((res) => {
                    localStorage.removeItem("loginInfo");
                    if (res?.type === "user/loginUser/fulfilled") {
                      navigate("/");
                    }
                  });
                }
              });
            }
          }
        }
      });
    },
  });

  const coverPhoto = addImages.find((item) => item.isCoverphoto && item.image);
  console.log(coverPhoto, "coverPhoto");
  useEffect(() => {
    if (values?.selectedState) {
      dispatch(fetchAllLgas(values?.selectedState));
    }
  }, [values.selectedState]);
  useEffect(() => {
    dispatch(fetchAllStates());
    dispatch(fetchImageLink());
  }, []);
  useEffect(() => {
    if (values?.selectedState) {
      const findStateName = allState?.find(
        (item) => Number(item?.id) === Number(values?.selectedState)
      );
      setStateName(findStateName?.name);
    }
  }, [values?.selectedState]);

  return (
    <div className="max-w-[90%] w-full mx-auto p-[40px]">
      <BusinessInfoHeader
        GalleryAdd={GalleryAdd}
        handleImageChange={handleImageChange}
        previewProfile={previewProfile}
        uploadingImage={uploadingImage}
      />
      <div className="businessInfo--body">
        <Accordion preExpanded={["a"]} allowZeroExpanded>
          <AccordionItem uuid="a">
            <BusinessAccordionHeader
              headerBody={
                "Detailed address of your center that can be found on google maps"
              }
              headerText={"Address *"}
            />
            <AccordionItemPanel>
              <AddBusinessAddressSection
                allState={allState}
                handleChange={handleChange}
                stateLga={stateLga}
                values={values}
              />
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
            <BusinessAccordionHeader
              headerBody={"Select your center's opening hours and days"}
              headerText={"Opening Hours *"}
            />
            <AccordionItemPanel>
              <Schedule daysOfWeek={daysOfWeek} setDaysOfWeek={setDaysOfWeek} />
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
            <BusinessAccordionHeader
              headerBody={"Upload photos of your center (min 2 and max. 4)"}
              headerText={" Center Images *"}
            />
            <AccordionItemPanel>
              <BusinessInfoImage
                addImages={addImages}
                handleCheckboxChange={handleCheckboxChange}
                handleImageMultipleChange={handleImageMultipleChange}
                showMoreInputs={showMoreInputs}
                visibleImageInputs={visibleImageInputs}
              />
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <BusinessAccordionHeader
              headerBody={
                "Adding your contact info help client connect with you easily."
              }
              headerText={"Contact "}
            />
            <AccordionItemPanel>
              <div className="add--input">
                <p>Instagram Link (Optional)</p>
                <Input
                  id="instaLink"
                  name="instaLink"
                  placeholder="Add instagram link"
                  label={"Add instagram link"}
                  value={values?.instaLink}
                  onChange={handleChange}
                />
              </div>
              <div className="add--input website">
                <p>Website (Optional)</p>
                <Input
                  id="websiteLink"
                  name="websiteLink"
                  placeholder="Add website link"
                  label={"Add website link"}
                  value={values?.websiteLink}
                  onChange={handleChange}
                />
              </div>
              <div className="add--input website">
                <p>Phone number</p>

                <div className="phoneInput">
                  <PhoneInput setPhoneDetails={setPhoneDetails} />
                </div>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
      <Button
        block={true}
        variant={"primary"}
        className={"mt-10"}
        disabled={isLoading ? true : false}
        onClick={() => submitForm()}
      >
        Save and Go to dashbord
      </Button>
    </div>
  );
};

export default InvitedProvidingOnboarding;
